interface State {
  loading: boolean
  reqingNum: number
  editing: boolean
}

export default {
  namespaced: true,
  state: {
    loading: false,
    reqingNum: 0,
    editing: false,
    renderSidebar: true,
    onLogin: null,
    loginPanel: 'login',
    toCreateShop: false,
    setupChangePWD: 0,
    memberDialog: false,
    newMemberActivity: false,
    d2dLoading: false // D2D加载状态
  },
  getters: {
    reqLoading (state: State): boolean {
      return state.reqingNum > 0
    }
  },
  mutations: {},
  actions: {
    setToCreateShop (
      {
        commit
      }: { commit: any },
      toCreateShop: boolean
    ) {
      commit('toCreateShop', toCreateShop)
    }
  }
}
